import { saveAs } from 'file-saver';
import moment from 'moment';
import { combineReducers } from 'redux';

import AffiliateTypes from './types';

const exportCsv = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isExporting: true };
      case success:
        const dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([action.payload], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `meus-affiliados-${dateExport}.csv`);
        return { ...state, isExporting: false };
      case error:
        return { ...state, isExporting: false };
      default:
        return state;
    }
  };
};

export const affiliateReducer = combineReducers({
  list: AffiliateTypes.listAffiliates.getReducer(),
  configCustomCommission: AffiliateTypes.configCustomCommission.getReducer(),
  moderateAffiliate: AffiliateTypes.moderateAffiliate.getReducer(),
  export: AffiliateTypes.exportAffiliates.createReducer(exportCsv),
  notifications: AffiliateTypes.notifications.getReducer(),
});
